export default function Services() {
  const services = [
    {
      icon: 'https://stage.startertemplatecloud.com/e10/wp-content/uploads/sites/5/2021/01/ico_02.png',
      title: 'Derecho Laboral',
      description: 'El Derecho Laboral, también conocido como Derecho del Trabajo, se refiere al conjunto de normas jurídicas que regulan las relaciones laborales entre empleadores y trabajadores. Su objetivo principal es proteger los derechos y garantías de los trabajadores, estableciendo las obligaciones y responsabilidades tanto para empleadores como para empleados. Esta rama del derecho abarca aspectos como la contratación laboral, las condiciones de trabajo, los salarios, las jornadas laborales, la seguridad y salud en el trabajo, entre otros.'
    },
    {
      icon: 'https://stage.startertemplatecloud.com/e10/wp-content/uploads/sites/5/2021/01/ico_03.png',
      title: 'Derecho especializado en Seguridad Social',
      description: 'Esta rama del derecho es aquella que regula la relación de los ciudadanos con la Seguridad Social. En Quereda y Murcia somos especialistas en seguridad social y conocemos todo tipos de prestaciones a las que un trabajador que esté dado de alta tiene derecho, ya sea en el régimen general, de autónomo o especiales de la Seguridad Social.'
    }
  ];

  return (
    <section className="py-20 bg-[#2C3E50]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#34495E] rounded-lg p-8 hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center">
                  {index === 0 ? (
                    <i className="ri-scales-3-line text-5xl" style={{ color: '#A77047' }}></i>
                  ) : (
                    <i className="ri-shield-user-line text-5xl" style={{ color: '#A77047' }}></i>
                  )}
                </div>
              </div>
              <h3 className="font-heading text-xl font-bold text-white text-center mb-4">
                {service.title}
              </h3>
              <p className="text-white/80 text-sm leading-relaxed text-center">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}